// 设封面:走后端 gapi 收口(service-role)。
//
// 后端 SetFileCover 校验目标归属 + 封面来源图归属/active/image/≤5MB,
// 并建 system_cover 托管副本(见 server/internal/filemgmt/cover.go)。
// 前端不再直连 supabase 写 file_info.cover_file_info_id(列级直写通道已收口 gapi)。
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@dogdisk/shared'

export function useSetCover(
  // table 形参保留(调用点签名不变);当前仅 file_info。
  table: 'file_info',
  rowId: string,
  invalidateKey: readonly unknown[],
) {
  void table
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (coverFileInfoId: string | null) => {
      await apiClient.post(
        `/gapi/user/files/${encodeURIComponent(rowId)}/cover`,
        coverFileInfoId ? { cover_file_info_id: coverFileInfoId } : { clear: true },
      )
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: invalidateKey }),
  })
}
